import React from 'react'

import MdCheckBox from 'react-icons/lib/md/check-box'

import styles from './Messages.styl'

export default class Registry extends React.Component {
	componentDidMount() {
		document.body.style.overflow = 'hidden'
	}
	componentWillUnmount() {
		document.body.style.overflow = 'inherit'
	}
	render() {
		return (
			<section className={ styles.message_popup }>
				<div className={ styles.message_success }>
					<div className={ styles.message_container }>
						<i><MdCheckBox /></i>
						<h3>Obrigado! Entraremos em contacto contigo brevemente.</h3>
					</div>
				</div>
			</section>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/website/components/Messages/Registry.js